import React, { useState, Component, lazy, useEffect } from "react";
import axios from "axios";
import pdf from "../../catalogue.pdf";

const Catalogue = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <div className=" mb-3 bs-cover">
      <div className="p-5 bg-primary bs-cover mb-5">
        <div className="container text-center">
          <span className="display-5 px-3 text-light">Catalogue</span>
        </div>
      </div>
      <div className="container g-3 mb-5">
        <object
          data={pdf}
          type="application/pdf"
          width="100%"
          height={900}
        ></object>
      </div>
    </div>
  );
};

export default Catalogue;
